module.exports = __webpack_public_path__ + "img/picture_kmskcspvip06@2x.347f21d3.png";